import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_USER_PHONE_NUMBER
    SET_REFERRAL_MOBILE
    ACTIVATE_REFERRAL
    ACTIVATE_REFERRAL_SUCCESS
    ACTIVATE_REFERRAL_ERROR
    FETCH_REFERRAL_DETAILS
    FETCH_REFERRAL_DETAILS_SUCCESS
    FETCH_REFERRAL_DETAILS_ERROR
`,
    {
        prefix: "refer/"
    }
);
